<script>
/**
 * Imports
 */
import SignupNavigationItem from "./SignupNavigationItem.vue";

/**
 * Component: Navigation
 *
 * Navigation component used for displaying links to
 * the specific sections in the form.
 *
 * @author PH
 */
export default {
  computed: {
    items() {
      return this.$store.state.sections;
    }
  },
  components: { SignupNavigationItem }
};
</script>

<template>
  <div class="signup-navigation">
    <signup-navigation-item
      v-for="item in items"
      v-bind:key="item.id"
      v-bind:id="item.id"
      v-bind:title="item.title"
      v-bind:valid="item.valid"
      v-bind:active="item.active"
    ></signup-navigation-item>
  </div>
</template>

